// removed by extract-text-webpack-plugin
module.exports = {"form-warning":"form-warning","complaint-input-file-wrap":"complaint-input-file-wrap","user-form-wrap":"user-form-wrap","inputfile":"inputfile","complaint-input-file":"complaint-input-file","complaint-content-wrap":"complaint-content-wrap","box-header":"box-header","complaint-content":"complaint-content","btn-post-complaint":"btn-post-complaint","select-category-wrap":"select-category-wrap","select-category":"select-category"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/complaint-form/_ComplaintForm.scss
// module id = ./components/users/sub-view/complaint-form/_ComplaintForm.scss
// module chunks = 0